import { LoadOptions } from 'devextreme/data/load_options';
import { action, computed, makeObservable, observable } from 'mobx';

import Wagon from '@stores/trackingStore/wagon/WagonTypes';

import service from './userOperationInfoStore.service';

class UserOperationInfoStore {
  @observable private _isLoading: boolean = false;
  @observable private _selectedIds: string[] = [];
  @observable private _showForm: boolean = false;
  @observable private _numbersFilterModalVisible: boolean = false;
  @observable private _filteredWagons: Wagon[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  async getReport(loadOptions: LoadOptions) {
    this._isLoading = true;
    try {
      if (this.filteredWagons.length) {
        loadOptions.filter = ['ui.wagon_number', 'in', '(' + this.filteredWagons.map((w) => w.number).join(',') + ')'];
      }
      return await service.getReport(loadOptions);
    } catch (e) {
      throw e;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async updateInfo(loadStationCode: number | null, destStationCode: number | null) {
    this._isLoading = true;
    try {
      await service.updateInfo(this._selectedIds, loadStationCode, destStationCode);
    } catch (e) {
      throw e;
    } finally {
      this._isLoading = false;
    }
  }

  @computed
  get isLoading(): boolean {
    return this._isLoading;
  }

  @computed
  get selectedIds(): string[] {
    return this._selectedIds;
  }

  @action
  setSelectedIds(ids: string[]) {
    this._selectedIds = ids;
  }

  @computed
  get showForm() {
    return this._showForm;
  }

  @action
  setShowForm(value: boolean) {
    this._showForm = value;
  }

  @computed
  get numbersFilterModalVisible() {
    return this._numbersFilterModalVisible;
  }

  set numbersFilterModalVisible(value: boolean) {
    this._numbersFilterModalVisible = value;
  }

  @computed
  get filteredWagons() {
    return this._filteredWagons;
  }

  set filteredWagons(value: Wagon[]) {
    this._filteredWagons = value;
  }
}
export const userOperationInfoStore = new UserOperationInfoStore();
